import React, { useEffect, useRef, useState } from 'react'
// import "./weblogin.scss"
import { useNavigate } from 'react-router-dom'
import { updateGrowProfile } from '../../Api';
import Swal from 'sweetalert2';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

const VideoComponent = ({ videoUrl, imageUrl, isPlaying, setIsPlaying }) => {
    const videoRef = useRef(null);
    return (
        <div className='main-video-sec w-100'>
            <div className={isPlaying ? 'd-none' : "video-image-div pointer"}>
                <img src={imageUrl} alt="" className='play-button' onClick={() => {
                    setIsPlaying(true)
                    if (videoRef.current) {
                        videoRef.current.play()
                    }
                }} />
            </div>
            <div className={!isPlaying ? 'd-none' : 'video-div w-100'}>
                <video className="w-100" style={{ height: '34vh', objectFit: 'cover' }}
                    ref={videoRef}
                    controls
                    disablePictureInPicture
                    muted
                    autoPlay
                    src={videoUrl}
                    onClick={() => {
                        if (!isPlaying) {
                            setIsPlaying(true); videoRef.current.play()
                        } else {
                            setIsPlaying(false); videoRef.current.pause()
                        }
                    }}
                    controlsList='noplaybackrate nofullscreen nodownload'
                    // onMouseEnter={() => {setIsPlaying(true); videoRef.current.play()}}
                    // onMouseLeave={() => {if(isPlaying === true){ setIsPlaying(false); videoRef.current.pause()} else{ setIsPlaying(true); videoRef.current.play()} }} 
                    onPause={() => { setIsPlaying(false) }} onEnded={() => { setIsPlaying(false) }}></video>
            </div>
        </div>
    )
}

function ChangePassword() {
    const navigate = useNavigate();
    const [userData, setUserData] = useState('');
    const [name, setName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    // const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    // const [showPassword2, setShowPassword2] = useState(false);
    const [isPlaying, setIsPlaying] = useState(true);

    const handleKeyDown = (ev) => {
        if (ev.key === "Enter") {
            ev.preventDefault();
            handleSubmit();
        }
    };

    const handleSubmit = async () => {
        Swal.fire({
            html: `<img src='/circle-1700_256.gif' style="height: 60px" alt="" />`,
            customClass: { popup: 'loader' },
            showConfirmButton: false,
            heightAuto: false
        })
        if (!name) {
            Swal.fire({
                text: 'First Name required!',
                showConfirmButton: false,
                icon: 'warning',
                iconColor: '#000',
                timer: 2000,
            })
            return;
        }else if (!companyName) {
            Swal.fire({
                text: 'Company Name required!',
                showConfirmButton: false,
                icon: 'warning',
                iconColor: '#000',
                timer: 2000,
            })
            return;
        }else if (!oldPassword) {
            Swal.fire({
                text: 'Old password required!',
                showConfirmButton: false,
                icon: 'warning',
                iconColor: '#000',
                timer: 2000,
            })
            return;
        } else if (!newPassword) {
            Swal.fire({
                text: 'New password required!',
                showConfirmButton: false,
                icon: 'warning',
                iconColor: '#000',
                timer: 2000,
            })
            return;
        } else if (oldPassword === newPassword) {
            Swal.fire({
                text: 'New password should not match with old password!',
                showConfirmButton: false,
                icon: 'warning',
                iconColor: '#000',
                timer: 2000,
            })
            return;
        } 
        // else if (!confirmPassword) {
        //     Swal.fire({
        //         text: 'Confirm password required!',
        //         showConfirmButton: false,
        //         icon: 'warning',
        //         iconColor: '#000',
        //         timer: 2000,
        //     })
        //     return;
        // } 
        // else if (confirmPassword !== newPassword) {
        //     Swal.fire({
        //         text: 'New password should match with confirm password!',
        //         showConfirmButton: false,
        //         icon: 'warning',
        //         iconColor: '#000',
        //         timer: 2000,
        //     })
        //     return;
        // } 
        else {
            let userData = JSON.parse(localStorage.getItem('userData') || '{}');
            let correl_id = localStorage.getItem('correl_id');
            let data = {
                correl_id,
                first_name: name,
                company_name: companyName,
                oldPassword,
                newPassword,
            }
            let apiRes = await updateGrowProfile(data);
            console.log(apiRes)
            if (apiRes.status === "S") {
                Swal.fire({
                    text: 'Your profile updated successfully. Redirecting to login',
                    icon: 'success',
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 2000
                }).then(() => {
                    if (userData.account_code === 'prod-owner') {
                        navigate('/')
                    } else {
                        navigate('/')
                    }
                })
            } else if (apiRes.status === 'E' && apiRes.result_code === 404) {
                Swal.fire({
                    text: 'User not found',
                    showConfirmButton: false,
                    icon: 'warning',
                    iconColor: '#000',
                    timer: 2000,
                })
            } else if (apiRes.status === 'E' && apiRes.result_code === 401) {
                Swal.fire({
                    text: 'Invalid Old password',
                    showConfirmButton: false,
                    icon: 'warning',
                    iconColor: '#000',
                    timer: 2000,
                })
            } else {
                Swal.close();
            }
        }
    }

    useEffect(() => {
        let userInfo = JSON.parse(localStorage.getItem('userData') || '{}');
        setUserData(userInfo);
        setName(userInfo.first_name)
        setCompanyName(userInfo.company_name)
      }, [])

    return (
        <div className='bootstrap-content weblogin-page'>
            <div className="row g-0 w-100 h-100" >
                <div className="col-6 d-none d-lg-block">
                    <div className="login-left">
                        <div className="ellipse"></div>
                        <h6 className='success-subheading'>Grow Your Business With Good Reviews</h6>
                        <img src={require('../../assets/gr-seal-logo.png')} alt="" className='login-left-image' />
                        {/* <h6 className='login-heading'>Tell Your Reviews </h6>
                        <h6 className='login-subheading'>We Make It Global</h6>
                        <div className={isPlaying ? "bg-color no-bg-img" : "bg-color"}>
                            <div className="image-container w-100">
                                <VideoComponent isPlaying={isPlaying} setIsPlaying={setIsPlaying} videoUrl={require('../../assets/output_HD1080.mp4')} imageUrl={require('../../assets/video-file.png')} />
                            </div>
                        </div> */}
                        <h6 className='login-desc mt-3'>Trusted By 10,000+ Global Companies of all sizes</h6>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/aws.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/microsoft.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/google-partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/katalon.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/partner.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/ware.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/citrix.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/salesforce.png')} alt="" className='logos' />
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/norton.png')} alt="" className='logos' />
                            </div>
                            <div className="col mb-2">
                                <img src={require('../../assets/left-website/symantec.png')} alt="" className='logos' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 h-100">
                    <div className="login-right">
                        <div className="login-card">
                            <div className="text-center">
                                <img src={require("../../assets/logo.png")} alt="" className='logo-image' />
                                <h6 className='login-welcometext'>Update your profile</h6>
                            </div>
                            <div className="text-start">
                                <div className="mb-3 text-start">
                                    <label for="name" className="form-label">Name</label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <input type="text"
                                            className="form-control"
                                            id="name"
                                            autoComplete="off"
                                            placeholder='Enter Name'
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 text-start">
                                    <label for="companyName" className="form-label">Company Name</label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <input type="text"
                                            className="form-control"
                                            id="companyName"
                                            autoComplete="off"
                                            placeholder='Enter Company Name'
                                            value={companyName}
                                            onChange={(e) => setCompanyName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 text-start">
                                    <label for="exampleInputPassword1" className="form-label">Old Password</label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <input type={showPassword ? "text" : 'password'}
                                            className="form-control"
                                            id="exampleInputPassword1"
                                            autoComplete="off"
                                            placeholder='Enter old Password'
                                            value={oldPassword}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                        />
                                        <span
                                            className="input-icon"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                                        </span>
                                    </div>

                                </div>
                                <div className="mb-3 text-start">
                                    <label for="exampleInputPassword1" className="form-label">New Password</label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <input type={showPassword1 ? "text" : 'password'}
                                            className="form-control"
                                            id="exampleInputPassword1"
                                            autoComplete="off"
                                            placeholder='Enter new Password'
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <span
                                            className="input-icon"
                                            onClick={() => setShowPassword1(!showPassword1)}
                                        >
                                            {showPassword1 ? <MdVisibility /> : <MdVisibilityOff />}
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="mb-3 text-start">
                                    <label for="exampleInputPassword1" className="form-label">Confirm Password</label>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <input type={showPassword2 ? "text" : 'password'}
                                            className="form-control"
                                            id="exampleInputPassword1"
                                            autoComplete="off"
                                            placeholder='Re-enter new Password'
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <span
                                            className="input-icon"
                                            onClick={() => setShowPassword2(!showPassword2)}
                                        >
                                            {showPassword2 ? <MdVisibility /> : <MdVisibilityOff />}
                                        </span>
                                    </div>

                                </div> */}
                                <button className='text-center btn btn-black' onClick={() => { handleSubmit() }}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ChangePassword
